export const DIRECTIONS = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
} as const;
